(()=>{
  const SELECTOR='[data-product-page]';

  function initProductPage(root){
    if(root.dataset.productInitialized==='true')return;
    root.dataset.productInitialized='true';

    const gallery=root.querySelector('[data-product-gallery]');
    const slides=gallery?[...gallery.querySelectorAll('[data-gallery-slide]')]:[];
    const thumbs=gallery?[...gallery.querySelectorAll('[data-gallery-thumb]')]:[];
    const prev=gallery?.querySelector('[data-gallery-prev]');
    const next=gallery?.querySelector('[data-gallery-next]');
    const viewport=gallery?.querySelector('[data-gallery-viewport]');
    const zoom=gallery?.querySelector('[data-product-zoom]');
    const zoomImage=zoom?.querySelector('[data-product-zoom-image]');
    const variantSelect=root.querySelector('[data-variant-select]');
    const optionGroups=[...root.querySelectorAll('[data-option-group]')];
    const priceWrap=root.querySelector('[data-product-price]');
    const priceCurrent=root.querySelector('[data-product-price-current]');
    const priceCompare=root.querySelector('[data-product-price-compare]');
    const saving=root.querySelector('[data-product-saving]');
    const availability=root.querySelector('[data-product-availability]');
    const sku=root.querySelector('[data-product-sku]');
    const mainAdd=root.querySelector('[data-cart-submit]');
    const addLabel=root.querySelector('[data-add-label]');
    const sticky=root.querySelector('[data-sticky-buy]');
    const stickyPrice=root.querySelector('[data-sticky-price]');
    const stickyButton=root.querySelector('[data-sticky-submit]');
    const stickyLabel=root.querySelector('[data-sticky-label]');
    const buyArea=root.querySelector('[data-main-buy-area]');
    const quantityInput=root.querySelector('[data-quantity-input]');
    const quantitySubmit=root.querySelector('[data-quantity-submit]');
    const form=root.querySelector('.product-form');
    const dynamicCheckout=root.querySelector('.product-form__dynamic');
    const rtl=getComputedStyle(root).direction==='rtl';
    const arabicLocale=(root.dataset.locale||document.documentElement.lang||'').toLowerCase().startsWith('ar');
    const toAsciiDigits=(value)=>String(value).replace(/[٠-٩]/g,(digit)=>String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)));
    const toArabicDigits=(value)=>String(value).replace(/[0-9]/g,(digit)=>'٠١٢٣٤٥٦٧٨٩'[Number(digit)]);
    const localizeDigits=(value)=>arabicLocale?toArabicDigits(value):String(value);
    const t=(key,fallback)=>root.dataset[key]||fallback;
    const lowStock=(count)=>t('tLowStock','Only __COUNT__ left').replace('__COUNT__',localizeDigits(count));
    const savePercent=(percent)=>t('tSave','Save __PERCENT__%').replace('__PERCENT__',localizeDigits(percent));
    let fulfillment=root.querySelector('[data-product-fulfillment]');
    let pickupRequest=0;
    let activeIndex=Math.max(0,slides.findIndex((slide)=>slide.classList.contains('is-active')));
    let touchStartX=null;
    let touchStartY=null;
    let previewBarMutationObserver=null;

    if(sticky&&dynamicCheckout)root.classList.add('has-sticky-payment');

    function previewBarOffset(){
      const previewPresent=document.getElementById('preview-bar-iframe')||document.getElementById('PBarNextFrameWrapper');
      if(!previewPresent)return 0;
      const paddingBottom=parseFloat(window.getComputedStyle(document.documentElement).paddingBottom)||0;
      if(paddingBottom<=0||paddingBottom>180)return 0;
      return Math.ceil(paddingBottom);
    }

    function syncStickyOffset(){
      const offset=previewBarOffset();
      if(sticky)sticky.style.bottom=offset>0?`${offset}px`:'';
      if(dynamicCheckout)dynamicCheckout.style.bottom=offset>0?`calc(${offset}px + .55rem + env(safe-area-inset-bottom))`:'';
    }

    function watchPreviewBar(){
      if(!sticky)return;
      syncStickyOffset();
      window.requestAnimationFrame(syncStickyOffset);
      window.setTimeout(syncStickyOffset,500);
      if(!('MutationObserver'in window))return;
      previewBarMutationObserver=new MutationObserver(syncStickyOffset);
      previewBarMutationObserver.observe(document.documentElement,{attributes:true,attributeFilter:['style']});
    }

    function setStickyVisible(visible){
      if(!sticky)return;
      const mobile=window.matchMedia('(max-width: 749px)').matches;
      const show=Boolean(visible&&mobile);
      sticky.setAttribute('aria-hidden',show?'false':'true');
      root.classList.toggle('has-sticky-buy-visible',show);
      if(show)syncStickyOffset();
    }

    function syncStickyFromPosition(){
      if(!sticky||!buyArea)return;
      const rect=buyArea.getBoundingClientRect();
      setStickyVisible(rect.bottom<=0);
    }

    function ensureFulfillment(){
      if(fulfillment||!form)return fulfillment;
      fulfillment=document.createElement('div');
      fulfillment.className='product-fulfillment';
      fulfillment.dataset.productFulfillment='';
      fulfillment.innerHTML=`<div class="product-fulfillment__row product-fulfillment__row--delivery"><span class="product-fulfillment__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 7.5h11v9H3zM14 10h3.5l3 3v3.5H14zM7 19a1.75 1.75 0 1 0 0-3.5A1.75 1.75 0 0 0 7 19Zm10.5 0a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg></span><div class="product-fulfillment__content"><strong>${t('tExpectedDelivery','Expected delivery')}</strong><span>${t('tDeliveryCheckout','Delivery options and timing are confirmed at checkout.')}</span><small>${t('tDeliveryDetail','Timing depends on your location and item availability.')}</small></div></div><div data-pickup-availability aria-live="polite"></div>`;
      form.insertAdjacentElement('afterend',fulfillment);
      fulfillment.addEventListener('click',(event)=>{
        if(event.target.closest('[data-pickup-modal-open]'))fulfillment.querySelector('[data-pickup-dialog]')?.showModal?.();
        if(event.target.closest('[data-pickup-modal-close]'))fulfillment.querySelector('[data-pickup-dialog]')?.close?.();
      });
      fulfillment.addEventListener('click',(event)=>{
        const dialog=event.target.closest('[data-pickup-dialog]');
        if(dialog&&event.target===dialog)dialog.close?.();
      });
      return fulfillment;
    }

    async function refreshPickup(variantId){
      const holder=ensureFulfillment()?.querySelector('[data-pickup-availability]');
      if(!holder||!variantId)return;
      const requestId=++pickupRequest;
      holder.innerHTML='<div class="product-fulfillment__loading">'+t('tPickupLoading','Checking store pickup availability…')+'</div>';
      try{
        const rootPath=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${rootPath}variants/${variantId}/?section_id=pickup-availability`,{headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)throw new Error('pickup unavailable');
        const html=await response.text();
        if(requestId!==pickupRequest)return;
        const doc=new DOMParser().parseFromString(html,'text/html');
        const content=doc.querySelector('[data-pickup-section]');
        holder.innerHTML=content?content.outerHTML:'<div class="product-fulfillment__row product-fulfillment__row--pickup"><div class="product-fulfillment__content"><strong>'+t('tPickupHeading','Pickup / Store availability')+'</strong><span>'+t('tPickupUnavailable','Store pickup availability is not available for this variant.')+'</span></div></div>';
      }catch(error){
        if(requestId!==pickupRequest)return;
        holder.innerHTML='<div class="product-fulfillment__row product-fulfillment__row--pickup"><div class="product-fulfillment__content"><strong>'+t('tPickupHeading','Pickup / Store availability')+'</strong><span>'+t('tPickupRetry','Check pickup availability again shortly or at checkout.')+'</span></div></div>';
      }
    }

    function pauseMedia(){
      slides.forEach((slide)=>{
        slide.querySelectorAll('video').forEach((video)=>video.pause?.());
        slide.querySelectorAll('iframe').forEach(()=>{});
      });
    }

    function showMedia(mediaId){
      if(!slides.length)return;
      let index=slides.findIndex((slide)=>String(slide.dataset.mediaId)===String(mediaId));
      if(index<0)index=0;
      pauseMedia();
      slides.forEach((slide,i)=>{
        const active=i===index;
        slide.hidden=!active;
        slide.classList.toggle('is-active',active);
      });
      thumbs.forEach((thumb,i)=>{
        const active=i===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
      });
      activeIndex=index;
      thumbs[index]?.scrollIntoView?.({behavior:'smooth',block:'nearest',inline:'nearest'});
    }

    function moveGallery(direction){
      if(slides.length<2)return;
      showMedia(slides[(activeIndex+direction+slides.length)%slides.length]?.dataset.mediaId);
    }

    thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>showMedia(thumb.dataset.mediaId)));
    prev?.addEventListener('click',()=>moveGallery(-1));
    next?.addEventListener('click',()=>moveGallery(1));

    viewport?.addEventListener('touchstart',(event)=>{
      if(event.touches.length!==1)return;
      touchStartX=event.touches[0].clientX;
      touchStartY=event.touches[0].clientY;
    },{passive:true});
    viewport?.addEventListener('touchend',(event)=>{
      if(touchStartX===null||touchStartY===null||!event.changedTouches.length)return;
      const dx=event.changedTouches[0].clientX-touchStartX;
      const dy=event.changedTouches[0].clientY-touchStartY;
      touchStartX=null;touchStartY=null;
      if(Math.abs(dx)>46&&Math.abs(dx)>Math.abs(dy)*1.25)moveGallery(dx*(rtl?1:-1)>0?1:-1);
    },{passive:true});

    gallery?.addEventListener('click',(event)=>{
      const trigger=event.target.closest('[data-product-zoom-open]');
      if(trigger&&zoom&&zoomImage){
        zoomImage.src=trigger.dataset.zoomSrc||'';
        zoomImage.alt=trigger.dataset.zoomAlt||'';
        if(typeof zoom.showModal==='function')zoom.showModal();
        return;
      }
      if(event.target.closest('[data-product-zoom-close]'))zoom?.close?.();
    });
    zoom?.addEventListener('click',(event)=>{if(event.target===zoom)zoom.close?.();});
    zoom?.addEventListener('close',()=>{if(zoomImage){zoomImage.src='';zoomImage.alt='';}});

    function selectedValues(){
      return optionGroups.map((group)=>group.querySelector('input:checked')?.value||'');
    }

    function findVariant(){
      if(!variantSelect)return null;
      if(!optionGroups.length)return variantSelect.selectedOptions[0]||null;
      const values=selectedValues();
      return [...variantSelect.options].find((option)=>{
        return [option.dataset.option1||'',option.dataset.option2||'',option.dataset.option3||''].slice(0,values.length).every((value,index)=>value===values[index]);
      })||null;
    }

    function updateVariant(){
      const selected=findVariant();
      optionGroups.forEach((group)=>{
        const label=group.querySelector('[data-option-selected]');
        const checked=group.querySelector('input:checked');
        if(label&&checked)label.textContent=checked.value;
      });
      if(!selected){
        if(mainAdd){mainAdd.disabled=true;}
        if(stickyButton){stickyButton.disabled=true;}
        if(addLabel)addLabel.textContent=t('tUnavailable','Unavailable');
        if(stickyLabel)stickyLabel.textContent=t('tUnavailable','Unavailable');
        if(availability){availability.textContent=t('tUnavailable','Unavailable');availability.classList.add('is-unavailable');}
        return;
      }

      variantSelect.value=selected.value;
      const available=selected.dataset.available==='true';
      const compareHtml=selected.dataset.compareHtml||'';
      const discount=Number(selected.dataset.discount||0);
      const inventory=Number(selected.dataset.inventory||0);
      const managed=selected.dataset.inventoryManaged==='true';
      const mediaId=selected.dataset.mediaId;

      if(priceCurrent)priceCurrent.innerHTML=selected.dataset.priceHtml||'';
      if(stickyPrice)stickyPrice.innerHTML=selected.dataset.priceHtml||'';
      if(priceCompare){priceCompare.innerHTML=compareHtml;priceCompare.hidden=!compareHtml;}
      if(saving){saving.textContent=discount>0?savePercent(discount):'';saving.hidden=discount<=0;}
      priceWrap?.classList.toggle('product-price--sale',discount>0);

      if(availability){
        availability.classList.toggle('is-unavailable',!available);
        if(!available)availability.textContent=t('tSoldOut','Sold out');
        else if(managed&&inventory>0&&inventory<=5)availability.textContent=lowStock(inventory);
        else availability.textContent=t('tInStock','In stock');
      }

      if(sku){
        const value=selected.dataset.sku||'';
        const span=sku.querySelector('span');
        if(span)span.textContent=value;
        sku.hidden=!value;
      }

      if(mainAdd)mainAdd.disabled=!available;
      if(stickyButton)stickyButton.disabled=!available;
      if(addLabel)addLabel.textContent=available?t('tAdd','Add to cart'):t('tSoldOut','Sold out');
      if(stickyLabel)stickyLabel.textContent=available?t('tAdd','Add to cart'):t('tSoldOut','Sold out');
      if(mediaId)showMedia(mediaId);
      refreshPickup(selected.value);

      const url=new URL(window.location.href);
      url.searchParams.set('variant',selected.value);
      window.history.replaceState({},'',url);
    }

    optionGroups.forEach((group)=>group.addEventListener('change',updateVariant));

    function setQuantity(value){
      if(!quantityInput)return;
      const parsed=Math.max(1,Number(toAsciiDigits(value).replace(/[^0-9]/g,''))||1);
      quantityInput.value=localizeDigits(parsed);
      if(quantitySubmit)quantitySubmit.value=String(parsed);
    }

    root.querySelector('[data-quantity-minus]')?.addEventListener('click',()=>{
      if(!quantityInput)return;
      setQuantity((Number(toAsciiDigits(quantityInput.value))||1)-1);
      quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click',()=>{
      if(!quantityInput)return;
      setQuantity((Number(toAsciiDigits(quantityInput.value))||1)+1);
      quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
    });
    quantityInput?.addEventListener('input',()=>{
      const cleaned=toAsciiDigits(quantityInput.value).replace(/[^0-9]/g,'');
      if(cleaned)quantityInput.value=arabicLocale?toArabicDigits(cleaned):cleaned;
    });
    quantityInput?.addEventListener('change',()=>setQuantity(quantityInput.value));
    setQuantity(quantityInput?.value||1);

    if(sticky&&buyArea){
      if('IntersectionObserver'in window){
        const observer=new IntersectionObserver((entries)=>{
          const entry=entries[0];
          setStickyVisible(Boolean(entry&&!entry.isIntersecting&&entry.boundingClientRect.bottom<=0));
        },{threshold:.15});
        observer.observe(buyArea);
      }else{
        window.addEventListener('scroll',syncStickyFromPosition,{passive:true});
      }
      window.addEventListener('resize',()=>{syncStickyOffset();syncStickyFromPosition();},{passive:true});
      window.addEventListener('pageshow',syncStickyFromPosition,{passive:true});
      watchPreviewBar();
      syncStickyFromPosition();
    }

    ensureFulfillment();
    updateVariant();
  }

  function init(scope=document){scope.querySelectorAll(SELECTOR).forEach(initProductPage);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();
